import { Box } from '@mui/material'
import { NavLink } from 'react-router-dom'
import { navigationItems } from '@/data/navigation'

/**
 * Desktop Navigation Links Component
 * Renders horizontal navigation with React Router
 */
export const Navigation = () => {
  return (
    <Box
      component="nav"
      sx={{
        display: { xs: 'none', md: 'flex' },
        gap: 4,
        alignItems: 'center',
      }}
    >
      {navigationItems.map((item) => (
        <NavLink
          key={item.href}
          to={item.href}
          style={({ isActive }) => ({
            color: isActive ? 'inherit' : 'inherit',
            fontWeight: isActive ? 600 : 400,
            fontSize: '1rem',
            textDecoration: 'none',
            transition: 'color 0.3s ease',
          })}
        >
          {({ isActive }) => (
            <Box
              component="span"
              sx={{
                color: isActive ? '#fbbf24' : '#ffffff',
                fontWeight: isActive ? 600 : 500,
                '&:hover': {
                  color: '#fbbf24',
                },
              }}
            >
              {item.label}
            </Box>
          )}
        </NavLink>
      ))}
    </Box>
  )
}
